import {
    FETCH_COMPLAINTS,
    CLEAN_COMPLAINTS,
    DELETE_COMPLAINT,
    DELETE_COMPLAINTS,
    CHANGE_COMPLAINT_STATUS,
    SEND_COMPLAINTS,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const COMPLAINTS_DEFAULT_STATE = {};

/**
 * Reducer pre reklamacie.
 */
const ComplaintsReducer = (state = COMPLAINTS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_COMPLAINTS:
            // Nacitanie reklamacii
            return payload;

        case CHANGE_COMPLAINT_STATUS:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, status: payload.status, data: { ...item.data, ...payload.data } };
                }

                return item;
            }) };

        case SEND_COMPLAINTS:
            // Odoslanie objednavok
            const { packages, datas } = payload;

            return { ...state, items: _.map(state.items, item => {
                if (!_.isEmpty(datas[toNumber(item.id)])) {
                    // Nasli sme objednavku nastavime data
                    const new_data = datas[toNumber(item.id)];

                    item = { ...item, data: new_data, status: new_data.status, package: new_data.package };
                }

                return item;
            }) };

        case CLEAN_COMPLAINTS:
        case DELETE_COMPLAINT:
        case DELETE_COMPLAINTS:
            // Vycistenie reklamacii
            // Zmazanie reklamacie
            // Zmazanie reklamacii cez multiselect
            return COMPLAINTS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default ComplaintsReducer;
